import React, { useState, useEffect, useRef, useContext } from "react";
import "../css/buypolicies.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/navigation";
import { Helmet } from 'react-helmet-async';
import ChatbotAi from "../components/ChatbotAi";
import { UserContext } from "../UserContext";
import axios from "axios";
const BuyPolicies = () => {
  const [InsuranceType, setInsuranceType] = useState("");
  const [WhoToInsure, setSelectedMembers] = useState("");
  const [openDropdown, setOpenDropdown] = useState(null);
  const [Gender, setSelectedGender] = useState("");
  const [AnnualIncome, setSelectedIncome] = useState("");
  const [PreferredSumInsured, setSelectedSumInsured] = useState("");
  const [Name, setName] = useState("");
  const [DateofBirth, setDob] = useState(null);
  const [Email, setEmail] = useState("");
  const [CityPincode, setCitypincode] = useState();
  const [MobileNumber, setMobileNumber] = useState("");
  const [Successmessage, setSuccessmessage] = useState();
  const [Errormessage, setErrormessage] = useState();
  const [mobileError, setMobileError] = useState('');
  const [emailError, setEmailError] = useState('');
  const [isDisabled, setIsDisabled] = useState(false);
  const [showOtpPopup, setShowOtpPopup] = useState(false);
  const [OTP, setOtp] = useState("");
  const [Message, setMessage] = useState();
  const [embedVideos, setEmbedVideos] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [showSweetAlert, setShowSweetAlert] = useState(false);
  const API_URL_User = process.env.REACT_APP_MainSite_API_URL;
  const API_URL_Dash = process.env.REACT_APP_Dashboard_API_URL;
  const API_URL_Login = process.env.REACT_APP_Login_API_URL;
  const { UserId, user, UserToken, userRole, UserEmail, UserMobile, UserGender, UserDateOfBirth } = useContext(UserContext);
  const isLoggedIn = !!user && UserToken && userRole;
  const [errors, setErrors] = useState({
    InsuranceType: "",
    WhoToInsure: "",
    Gender: "",
    AnnualIncome: "",
    PreferredSumInsured: "",
  });

  useEffect(() => {
    GetAllBuyPoliciesVideo();
    GetPlanDetails();
    Userdetails(user, UserEmail, UserMobile, UserGender, UserDateOfBirth);
  }, [user, UserEmail, UserMobile, UserGender, UserDateOfBirth]);

  useEffect(() => {
    let timer;
    if (showSweetAlert) {
      timer = setTimeout(() => {
        setShowSweetAlert(false);
      }, 5000);
    }
    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [showSweetAlert]);

  const policies = [
    { id: "Life Insurance", label: "Life Insurance" },
    { id: "Health Insurance", label: "Health Insurance" },
    { id: "Home Insurance", label: "Home Insurance" },
    { id: "Two Wheeler Insurance", label: "Two Wheeler Insurance" },
    { id: "Motor Insurance", label: "Motor Insurance" },
    { id: "Cyber Insurance", label: "Cyber Insurance" },
    { id: "Shopkeeper Insurance", label: "Shopkeeper Insurance" },
    { id: "Personal Accidental Insurance", label: "Personal Accidental Insurance" },
    { id: "Critical Insurance", label: "Critical Insurance" },
    { id: "Insurance with Investment", label: "Insurance with Investment" },
  ];

  const membersOptions = ["Self", "Spouse", "Father", "Mother", "Son", "Daughter"];

  const genderOptions = [
    { id: "Male", label: "Male" },
    { id: "Female", label: "Female" },
    { id: "Other", label: "Other" },
  ];

  const incomeOptions = [
    { id: "below5", label: "Below ₹5 Lakh" },
    { id: "5-10", label: "₹5 Lakh - ₹10 Lakh" },
    { id: "10-20", label: "₹10 Lakh - ₹20 Lakh" },
    { id: "20plus", label: "Above ₹20 Lakh" },
  ];

  const sumInsuredOptions = [
    { id: "1cr", label: "₹1 Cr" },
    { id: "5cr", label: "₹5 Cr" },
    { id: "10cr", label: "₹10 Cr" },
    { id: "10cr_above", label: "₹10 Cr & Above" },
  ];

  const toggleDropdown = (dropdownName) => {
    setOpenDropdown(openDropdown === dropdownName ? null : dropdownName);
  };

  const handleInsuranceSelect = (insuranceType) => {
    setInsuranceType(insuranceType);
    setErrors(prev => ({ ...prev, InsuranceType: "" }));
    setOpenDropdown(null);
  };

  const handleMemberSelect = (member) => {
    setSelectedMembers(member);
    setErrors(prev => ({ ...prev, WhoToInsure: "" }));
    setOpenDropdown(null);
  };

  const handleGenderSelect = (genderId) => {
    setSelectedGender(genderId);
    setErrors(prev => ({ ...prev, Gender: "" }));
    setOpenDropdown(null);
  };

  const handleIncomeSelect = (incomeId) => {
    setSelectedIncome(incomeId);
    setErrors(prev => ({ ...prev, AnnualIncome: "" }));
    setOpenDropdown(null);
  };

  const handleSumInsuredSelect = (sumId) => {
    setSelectedSumInsured(sumId);
    setErrors(prev => ({ ...prev, PreferredSumInsured: "" }));
    setOpenDropdown(null);
  };


  const AddBuypolicy = async (e) => {
    e?.preventDefault();

    let isValid = true;
    let newErrors = {
      InsuranceType: "",
      WhoToInsure: "",
      Gender: "",
      AnnualIncome: "",
      PreferredSumInsured: "",
      Name: "",
      Email: "",
      MobileNumber: "",
      DateofBirth: "",
      CityPincode: ""
    };

    if (!Name.trim()) {
      newErrors.Name = "Name is required";
      isValid = false;
    }

    if (!Email.trim()) {
      newErrors.Email = "Email is required";
      isValid = false;
    } else {

    }

    if (!MobileNumber.trim()) {
      newErrors.MobileNumber = "Mobile number is required";
      isValid = false;
    } else {
      const indianMobilePattern = /^[6-9]\d{9}$/;
      if (!indianMobilePattern.test(MobileNumber)) {
        newErrors.MobileNumber = "Please enter valid mobile number";
        isValid = false;
      }
    }

    if (!DateofBirth) {
      newErrors.DateofBirth = "Date of Birth is required";
      isValid = false;
    }

    if (!CityPincode) {
      newErrors.CityPincode = "City/PIN Code is required";
      isValid = false;
    }

    if (!InsuranceType) {
      newErrors.InsuranceType = "Insurance Type is required";
      isValid = false;
    }

    if (InsuranceType === "Life Insurance" && !WhoToInsure) {
      newErrors.WhoToInsure = "Who Do You Want to Insure is required";
      isValid = false;
    }

    if (!Gender) {
      newErrors.Gender = "Gender is required";
      isValid = false;
    }

    if (["Life Insurance", "Critical Insurance", "Personal Accidental Insurance"].includes(InsuranceType)) {
      if (!AnnualIncome) {
        newErrors.AnnualIncome = "Annual Family Income is required";
        isValid = false;
      }
      if (!PreferredSumInsured) {
        newErrors.PreferredSumInsured = "Preferred Sum Insured is required";
        isValid = false;
      }
    }

    setErrors(newErrors);
    if (!isValid) {
      return;
    }

    if (UserId === null || UserId === 0) {
      setIsDisabled(true);

      try {
        const response = await axios.post(`${API_URL_Login}signup`, {
          Username: Name,
          Email,
          Mobile: MobileNumber,
          RoleName: "User",
        });
        if (response.status === 200) {
          setShowOtpPopup(true);
          setSuccessmessage("OTP successfully sent to your email. Please check");
          setTimeout(() => setSuccessmessage(""), 5000);
        }
      } catch (error) {
        if (error.response?.data?.errors === "Email id already registered. Please connect with administrator.") {
          try {
            const response = await axios.post(`${API_URL_Login}SendOtp`, { Email });
            if (response.status === 200) {
              setShowOtpPopup(true);
              setSuccessmessage("OTP successfully sent to your email. Please check");
              setTimeout(() => setSuccessmessage(""), 3000);
            }
          } catch (otpError) {
            setErrormessage(otpError.response?.data?.error || "Failed to send OTP.");
          }
        } else {
          setErrormessage(error.response?.data?.errors || "Something went wrong during signup.");
          setTimeout(() => setErrormessage(""), 5000);
        }
      } finally {
        setIsDisabled(false);
      }
      return;
    }

    setErrormessage("");
    setIsDisabled(true);

    const InquiryType = "Buy Policy Inquiry";
    const Status = "New";

    try {
      const response = await axios.post(`${API_URL_User}Buypolicy`, {
        Name,
        DateofBirth,
        Email,
        CityPincode,
        MobileNumber,
        InsuranceType,
        WhoToInsure,
        Gender,
        AnnualIncome,
        PreferredSumInsured,
        Status,
        InquiryType,
        UserId
      });

      if (response.status === 200) {
        setShowSweetAlert(true);
        setSuccessmessage(response.data.message);

        // Reset form fields after success
        setTimeout(() => {
          setSuccessmessage("");
          setName("");
          setDob("");
          setEmail("");
          setCitypincode("");
          setMobileNumber("");
          setInsuranceType("");
          setSelectedMembers("");
          setSelectedGender("");
          setSelectedIncome("");
          setSelectedSumInsured("");
          setErrors({
            InsuranceType: "",
            WhoToInsure: "",
            Gender: "",
            AnnualIncome: "",
            PreferredSumInsured: "",
            Name: "",
            Email: "",
            MobileNumber: "",
            DateofBirth: "",
            CityPincode: ""
          });
          setIsDisabled(false);
        }, 5000);
      } else {
        setErrormessage("An unexpected error occurred.");
        setIsDisabled(false);
      }
    } catch (error) {
      setErrormessage(error.response?.data?.Errormessage || "Something went wrong. Please try again.");
      setIsDisabled(false);
      setTimeout(() => setErrormessage(""), 5000);
    }
  };

  const handleNameChange = (value) => {
    setName(value);
    setErrors(prevErrors => {
      const newErrors = { ...prevErrors };
      if (!value.trim()) newErrors.Name = "Name is required";
      else if (!/^[A-Za-z\s]*$/.test(value)) newErrors.Name = "Please enter valid full name";
      else newErrors.Name = "";
      return newErrors;
    });
  };

  const handleDateChange = (value) => {
    setDob(value);
    setErrors(prevErrors => {
      const newErrors = { ...prevErrors };
      if (!value) newErrors.DateofBirth = "Date of Birth is required";
      else newErrors.DateofBirth = "";
      return newErrors;
    });
  };


  const handleMobileChange = (value) => {
    setMobileNumber(value);
    const indianMobilePattern = /^[6-9]?\d{0,9}$/;
    setErrors(prevErrors => {
      const newErrors = { ...prevErrors };
      if (!value.trim()) newErrors.MobileNumber = "Mobile number is required";
      else if (!indianMobilePattern.test(value)) newErrors.MobileNumber = "Please enter valid mobile number";
      else newErrors.MobileNumber = "";
      return newErrors;
    });
  };

  const handleCityPincodeChange = (value) => {
    setCitypincode(value);
    setErrors(prevErrors => {
      const newErrors = { ...prevErrors };
      if (!value.trim()) newErrors.CityPincode = "City/PIN Code is required";
      else newErrors.CityPincode = "";
      return newErrors;
    });
  };


  const validateEmail = (email) => {
    setEmail(email);

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    setErrors(prevErrors => {
      const newErrors = { ...prevErrors };
      if (!email.trim()) newErrors.Email = "Email is required";
      else if (!emailRegex.test(email)) newErrors.Email = "Please enter a valid email address";
      else newErrors.Email = "";
      return newErrors;
    });
  };

  const handleVerifyOtp = async () => {
    try {
      let UserId = null;
      const response = await axios.post(`${API_URL_Login}verify-otp`, {
        Email,
        OTP
      });
      if (response.status === 200) {
        setMessage(response.data.message);
        UserId = response.data.id;
        setTimeout(() => {
          setShowOtpPopup(false);
          setOtp("")
          setMessage("");
        }, 2000);
        try {

          const InquiryType = "Buy Policy Inquiry"
          const Status = "New"
          const response = await axios.post(`${API_URL_User}` + "Buypolicy", {
            Name,
            DateofBirth,
            Email,
            CityPincode,
            MobileNumber,
            InsuranceType,
            WhoToInsure,
            Gender,
            AnnualIncome,
            PreferredSumInsured,
            Status,
            InquiryType,
            UserId
          });
          if (response.status == 200) {
            setShowSweetAlert(true);
            setSuccessmessage(response.data.message);
            setTimeout(() => {
              setSuccessmessage("");
              setName("");
              setDob("");
              setEmail("");
              setCitypincode("");
              setMobileNumber("");
              setInsuranceType("");
              setSelectedMembers("");
              setSelectedGender("");
              setSelectedIncome("");
              setSelectedSumInsured("");
              // setSelectedDuration("");

            }, 5000);
          }
          else {
            setErrormessage("");
          }
        } catch (error) {
          setErrormessage(error.response?.data?.Errormessage);
          setTimeout(() => {
            setErrormessage("");
          }, 5000);
        }
      } else {
        setTimeout(() => {
          setMessage(response.data.message || "Invalid OTP");
        }, 2000);
      }
    } catch (error) {
      setTimeout(() => {
        setMessage(error.response?.data?.error);
      }, 2000);
    }
  };
  const handleResendOtp = async () => {
    setOtp("");
    try {
      const response = await axios.post(`${API_URL_Login}SendOtp`, { Email });
      if (response.status === 200) {
        setSuccessmessage("OTP resent successfully");
        setTimeout(() => setSuccessmessage(""), 3000);
      }
    } catch (error) {
      setErrormessage("Failed to resend OTP");
      setTimeout(() => setErrormessage(""), 3000);
    }
  };
  const extractVideoId = (url) => {
    const regex = /(?:youtube\.com\/.*[?&]v=|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
    const match = url.match(regex);
    return match ? match[1] : "";
  };

  const [comparisonPlans, setComparisonPlans] = useState([]);
  const GetPlanDetails = async () => {
    try {
      const response = await axios.get(API_URL_Dash + "BuyPoliciesPlan");
      if (response.status === 200) {
        setComparisonPlans(response.data);
      } else {

      }
    } catch (error) {
      console.warn(error?.response?.data?.message);
    }
  };

  const Userdetails = async (user, UserEmail, UserMobile, UserGender, UserDateOfBirth) => {
    if (user, UserEmail, UserMobile) {
      // setId (user.id),
      setName(user);
      setEmail(UserEmail);
      setMobileNumber(UserMobile);
      setDob(UserDateOfBirth);
      setSelectedGender(UserGender);
    } else {
      console.warn("No User found with ID:", UserId);
    }
  };

  const GetAllBuyPoliciesVideo = async () => {
    try {
      const response = await axios.get(API_URL_Dash + "AllBuyPoliciesVideo");
      if (response.status === 200) {
        const embedUrls = response.data
          .map((item) => extractVideoId(item.videoUrl))
          .filter(Boolean);
        setEmbedVideos(embedUrls);
        setActiveIndex(0);
      } else {
        console.error("Videos not found");
      }
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  const handleSlideChange = (swiper) => {
    setActiveIndex(swiper.realIndex);
  };

  return (
    <div className="buypolicies-wrapper">
      <Helmet>
        <title>Compare Insurance Plans | Find Best Coverage for You</title>
        <meta
          name="description"
          content="Easily compare insurance plans side by side. Find the best coverage, prices, and benefits to suit your needs with expert support. Get your insurance policy reviewed by experts to understand your coverage fully and avoid costly mistakes."
        />
        <meta
          name="keywords"
          content="insurance guidance, policy consultation, insurance expert advice, clarity in insurance, compare insurance policies, best insurance policies India, insurance policy review, policy upload, personalized insurance recommendations India, insurance policy explanation, insurance advice India, insurance policy help, understand insurance policy, insurance policy consultation India, how to understand your insurance policy, upload insurance policy for advice, personalized insurance advice in India, insurance policy mistakes to avoid, best health insurance plan advice, what does an insurance policy cover, insurance policy explanations for beginners, compare term insurance plans India, insurance consultation near me, insurance experts for personalized advice, insurance policy FAQs India, buy insurance online India, compare insurance policies India"
        />
        <link rel="canonical" href="https://policysamjho.com/buy-policies/" />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Service",
            "serviceType": "Insurance Policy Purchase",
            "name": "Buy Insurance Policies With Confidence",
            "description": "Explore top insurance policies with expert support. We guide you step-by-step to buy the best policy that fits your needs and budget.",
            "url": "https://policysamjho.com/buy-policies/",
            "provider": {
              "@type": "Organization",
              "name": "PolicySamjho",
              "url": "https://policysamjho.com/"
            },
            "areaServed": {
              "@type": "Country",
              "name": "India"
            },
            "offers": {
              "@type": "Offer",
              "priceCurrency": "INR",
              "priceSpecification": {
                "@type": "UnitPriceSpecification",
                "priceType": "https://schema.org/Estimate"
              }
            }
          })}
        </script>
      </Helmet>
      <div className="buypolicies-left">
        <h1 className="main-page-heading" style={{ textAlign: "center", fontSize: "1rem", marginBottom: "10px" }}>
          Buy Insurance Policies With Confidence
        </h1>

        <h2 className="buypolicies-heading" style={{ textAlign: "center" }}>
          <span className="heading-part-dark">Explore Our</span>{" "}
          <span className="heading-part-yellow">Product Range</span>
        </h2>
        {embedVideos.length === 0 ? (
          <div className="text-center text-red-600 font-semibold mt-4">
            No video available!
          </div>
        ) : (
          <Swiper
            direction="horizontal"
            modules={[Navigation]}
            loop={embedVideos.length > 1}
            slidesPerView={1}
            spaceBetween={20}
            navigation={true}
            onSlideChange={handleSlideChange}
            className="productrange-slider"
          >
            {embedVideos.map((videoId, idx) => (
              <SwiperSlide key={idx}>
                <div style={{ position: "relative", paddingBottom: "56.25%", height: 0 }}>
                  {activeIndex === idx && (
                    <iframe
                      // src={`https://www.youtube.com/embed/${videoId}?autoplay=0&mute=0&loop=0&enablejsapi=1&rel=0&showinfo=0&playlist=${videoId}`}
                      src={`https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&loop=1&playlist=${videoId}`}
                      frameBorder="0"
                      allow="autoplay; encrypted-media"
                      allowFullScreen
                      title={`video-${idx}`}
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                      }}
                    />
                  )}
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        )}
        <div className="buypolicies-compare-plans">
          <h3 className="compare-heading">
            <span className="heading-part-dark">Plans from</span>{" "}
            <span className="heading-part-yellow">Top Insurers</span>
          </h3>
          {comparisonPlans.length === 0 ? (
            <div className="text-center text-red-600 font-semibold mt-4">
              No plans available!
            </div>
          ) : (
            <Swiper
              direction="horizontal"
              modules={[Autoplay, Navigation]}
              autoplay={{ delay: 5000, disableOnInteraction: false }}
              loop={comparisonPlans.length > 1}
              slidesPerView={1}
              spaceBetween={20}
              navigation={true}
              className="compare-plans-swiper"
            >
              {comparisonPlans.map((plan, idx) => (
                <SwiperSlide key={idx}>
                  <div className="compare-card">
                    <h2 className="compare-card-title">
                      {plan.title}
                    </h2>
                    <div className="plan-details-grid">
                      <div className="grid-item">
                        <i className="fas fa-circle dot-icon"></i> <span class="grid-label">Sum Insured:</span> {plan.suminsured}
                      </div>
                      <div className="grid-item">
                        <i className="fas fa-circle dot-icon"></i> <span class="grid-label">Features:</span> {plan.features}
                      </div>
                      <div className="grid-item">
                        <i className="fas fa-circle dot-icon"></i> <span class="grid-label">Network:</span> {plan.network}
                      </div>
                      <div className="grid-item">
                        <i className="fas fa-circle dot-icon"></i> <span class="grid-label">Premium:</span> {plan.premium}
                      </div>
                    </div>
                    <button
                      className="buypolicies-button card-button"
                      onClick={() => {
                        const fileName = plan.pdf?.split("\\").pop();
                        if (fileName) {
                          const url = `${API_URL_Dash}Document/${fileName}`;
                          window.open(url, "_blank", "noopener,noreferrer");
                        } else {
                          alert("No document found.");
                        }
                      }}
                    >
                      View Plan
                    </button>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          )}
        </div>
      </div>
      <div className="buypolicies-right">

        {showOtpPopup && (
          <div className="buypolicy-otp-popup">
            <div className="buypolicy-otp-content">
              <button
                onClick={() => setShowOtpPopup(false)}
                className="buypolicy-otp-close-btn"
              >
                ×
              </button>

              <h2 className="buypolicy-otp-heading">Enter OTP</h2>

              <input
                type="tel"
                maxLength={6}
                value={OTP}
                onChange={(e) => setOtp(e.target.value)}
                placeholder="Enter 6-digit OTP"
                className="buypolicy-otp-input"
              />

              <button
                onClick={handleVerifyOtp}
                className="buypolicy-otp-verify-btn"
              >
                Verify OTP
              </button>

              <div className="buypolicy-otp-resend">
                <span onClick={handleResendOtp}>Resend OTP</span>
              </div>

              {Message && (
                <p
                  className={
                    Message.includes("OTP Verified Successfully !")
                      ? "buypolicy-otp-success-msg"
                      : "buypolicy-otp-error-msg"
                  }
                >
                  {Message}
                </p>
              )}
              {Successmessage && (
                <div style={{ color: "green", fontSize: "14px", marginTop: "5px" }}>{Successmessage}</div>
              )}
            </div>
          </div>
        )}
        <form onSubmit={AddBuypolicy}>
          <div className="buypolicies-section">
            <h2 className="buypolicies-heading">
              <span className="heading-part-dark">Select Your</span>{" "}
              <span className="heading-part-yellow">Insurance Type</span>
            </h2>
            <div className="custom-dropdown-container">
              <div
                className="custom-dropdown-selected"
                onClick={() => toggleDropdown('insurance')}
              >
                {InsuranceType || "Select Insurance Type"}
              </div>
              {openDropdown === 'insurance' && (
                <div className="custom-dropdown-options">
                  {policies.map((policy) => (
                    <div
                      key={policy.id}
                      className={`custom-dropdown-option ${InsuranceType === policy.id ? 'selected-option' : ''}`}
                      onClick={() => handleInsuranceSelect(policy.id)}
                    >
                      {policy.label}
                    </div>
                  ))}
                </div>
              )}
            </div>
            {errors.InsuranceType && (
              <div className="bypolicyerror-message">{errors.InsuranceType}</div>
            )}
          </div>
          {InsuranceType === "Life Insurance" && (
            <div className="buypolicies-section">
              <h2 className="buypolicies-heading">
                <span className="heading-part-dark">Who Do You </span>{" "}
                <span className="heading-part-yellow">Want to Insure?</span>
              </h2>
              <div className="custom-dropdown-container">
                <div
                  className="custom-dropdown-selected"
                  onClick={() => toggleDropdown('members')}
                >
                  {WhoToInsure || "Select Member"}
                </div>
                {openDropdown === 'members' && (
                  <div className="custom-dropdown-options">
                    {membersOptions.map((member) => (
                      <div
                        key={member}
                        className={`custom-dropdown-option ${WhoToInsure === member ? 'selected-option' : ''}`}
                        onClick={() => handleMemberSelect(member)}
                      >
                        {member}
                      </div>
                    ))}
                  </div>
                )}
              </div>
              {errors.WhoToInsure && (
                <div className="bypolicyerror-message">{errors.WhoToInsure}</div>
              )}
            </div>
          )}
          <div className="buypolicies-section">
            <h2 className="buypolicies-heading">
              <span className="heading-part-dark"> Fill Your</span>{" "}
              <span className="heading-part-yellow">Basic Details</span>
            </h2>
            <div className="buypolicies-input-row">
              <div className="form-field-wrapper">
                <label>Full Name</label>
                <input
                  type="text"
                  value={Name}
                  onChange={(e) => handleNameChange(e.target.value)}
                  placeholder="Enter your full name"
                />
                {errors.Name && <div className="bypolicyerror-message">{errors.Name}</div>}

              </div>
              <div className="form-field-wrapper">
                <label>Date of Birth</label>
                <input
                  type="date"
                  value={DateofBirth}
                  onChange={(e) => handleDateChange(e.target.value)}
                  max={new Date().toISOString().split("T")[0]}
                />
                {errors.DateofBirth && <div className="bypolicyerror-message">{errors.DateofBirth}</div>}

              </div>
            </div>
            <div className="buypolicies-input-row">
              <div className="form-field-wrapper">
                <label>Your Gender</label>
                <div
                  className="custom-dropdown-selected"
                  onClick={() => toggleDropdown('gender')}
                >
                  {Gender || "Select Gender"}
                </div>
                {openDropdown === 'gender' && (
                  <div className="custom-dropdown-options">
                    {genderOptions.map((gender) => (
                      <div
                        key={gender.id}
                        className={`custom-dropdown-option ${Gender === gender.id ? 'selected-option' : ''}`}
                        onClick={() => handleGenderSelect(gender.id)}
                      >
                        {gender.label}
                      </div>
                    ))}
                  </div>
                )}
                {errors.Gender && (
                  <div className="bypolicyerror-message">{errors.Gender}</div>
                )}
              </div>
              <div className="form-field-wrapper">
                <label>City / PIN Code</label>
                <input
                  type="text"
                  value={CityPincode}
                  onChange={(e) => handleCityPincodeChange(e.target.value)}
                  placeholder="Enter your city/PIN code"
                />
                {errors.CityPincode && <div className="bypolicyerror-message">{errors.CityPincode}</div>}

              </div>
            </div>
            <div className="buypolicies-input-row">
              <div className="form-field-wrapper">
                <label>Mobile Number</label>
                <input
                  type="tel"
                  value={MobileNumber}
                  onChange={(e) => handleMobileChange(e.target.value)}
                  placeholder="Enter your mobile number"
                  maxLength={10}
                />
                {errors.MobileNumber && <div className="bypolicyerror-message">{errors.MobileNumber}</div>}
              </div>
              <div className="form-field-wrapper">
                <label>Email Address</label>
                <input
                  type="email"
                  value={Email}
                  onChange={(e) => validateEmail(e.target.value)}
                  placeholder="Enter your email address"
                />
                {errors.Email && (
                  <div className="bypolicyerror-message">{errors.Email}</div>
                )}
              </div>
            </div>
          </div>
          {(InsuranceType === "Life Insurance" ||
            InsuranceType === "Critical Insurance" ||
            InsuranceType === "Personal Accidental Insurance") && (
              <div className="buypolicies-section">
                <h2 className="buypolicies-heading">
                  <span className="heading-part-dark">Financial & </span>{" "}
                  <span className="heading-part-yellow">Coverage Details</span>
                </h2>

                <div className="buypolicies-input-row">
                  <div className="form-field-wrapper">
                    <label>Annual Family Income</label>
                    <div
                      className="custom-dropdown-selected"
                      onClick={() => toggleDropdown('income')}
                    >
                      {AnnualIncome ? incomeOptions.find(i => i.id === AnnualIncome)?.label : "Select Income"}
                    </div>
                    {openDropdown === 'income' && (
                      <div className="custom-dropdown-options">
                        {incomeOptions.map((income) => (
                          <div
                            key={income.id}
                            className={`custom-dropdown-option ${AnnualIncome === income.id ? 'selected-option' : ''}`}
                            onClick={() => handleIncomeSelect(income.id)}
                          >
                            {income.label}
                          </div>
                        ))}
                      </div>
                    )}
                    {errors.AnnualIncome && (
                      <div className="bypolicyerror-message">{errors.AnnualIncome}</div>
                    )}
                  </div>
                  <div className="form-field-wrapper">
                    <label>Preferred Sum Insured</label>
                    <div
                      className="custom-dropdown-selected"
                      onClick={() => toggleDropdown('sumInsured')}
                    >
                      {PreferredSumInsured ? sumInsuredOptions.find(s => s.id === PreferredSumInsured)?.label : "Select Sum Insured"}
                    </div>
                    {openDropdown === 'sumInsured' && (
                      <div className="custom-dropdown-options">
                        {sumInsuredOptions.map((sum) => (
                          <div
                            key={sum.id}
                            className={`custom-dropdown-option ${PreferredSumInsured === sum.id ? 'selected-option' : ''}`}
                            onClick={() => handleSumInsuredSelect(sum.id)}
                          >
                            {sum.label}
                          </div>
                        ))}
                      </div>
                    )}
                    {errors.PreferredSumInsured && (
                      <div className="bypolicyerror-message">{errors.PreferredSumInsured}</div>
                    )}
                  </div>
                </div>
              </div>
            )}

          <div className="buypolicies-button-container">
            <button type="submit" className="buypolicies-sub-button" disabled={isDisabled}>
              Submit
            </button>
          </div>

          {Errormessage && (
            <div className="bypolicyerror-message">{Errormessage}</div>
          )}
        </form>
        {showSweetAlert && (
          <div className="buypolicies-sweetalert-container">
            <div className="buypolicies-sweetalert-content">
              <button
                onClick={() => setShowSweetAlert(false)}
                className="buypolicies-sweetalert-close-btn"
              >
                ×
              </button>
              <div className="buypolicies-sweetalert-tick-icon">
                <i className="fas fa-check"></i>
              </div>
              <h2 className="buypolicies-sweetalert-title">Success!</h2>
              <p className="buypolicies-sweetalert-text">
                Inquiry added successfully <br />
                Our expert will call you soon.
              </p>
            </div>
          </div>
        )}
      </div>
      <ChatbotAi />
    </div>
  );
};

export default BuyPolicies;


